import React from "react";
import { Warning } from "MODULES/shared/components";
import ShippingFields from "MODULES/Orders/shared/ShippingFields";
import { Col } from "react-bootstrap";
import {
  RETURN_TO,
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_LOCATION_ID,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE
} from "APP_ROOT/constants";
import { COMPANY } from "MODULES/companies/constants";
import { DROPSHIP } from "MODULES/shared/components/ShippingSection/shippingTypes";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

function ShippingSection({
  formName,
  hasLocations,
  lineItem,
  displayShipmentUpdateReminder,
  disabled,
  shippingTypes = [COMPANY, DROPSHIP],
  ship_to_fields_required: shipToFieldsRequired = true
}) {
  return (
    <React.Fragment>
      <h5 className="h4" key="shipping-form-header">
        RETURNING
      </h5>
      <div className="row row-col-gutters-half">
        <Col md={12}>
          <ShippingFields
            formName={formName}
            shippingFields={[
              RETURN_TO_TYPE,
              RETURN_TO_COMPANY_ID,
              RETURN_TO_COMPANY_ADDRESS_ID
            ]}
            shippingTypes={shippingTypes}
            shippingType={RETURN_TO}
            shippingMethod={RETURN_TO_SHIPPING_METHOD}
            shippingAddressField={RETURN_TO_SHIPPING_ADDRESS}
            shipToCompany={lineItem && lineItem.return_to_company}
            ship_to_fields_required={shipToFieldsRequired}
            required={false}
            disabled={disabled}
            locationFieldName={RETURN_TO_LOCATION_ID}
            hasLocations={hasLocations}
          />
        </Col>
      </div>

      {displayShipmentUpdateReminder && (
        <Warning>
          Remember to send customer an email with AWB# and shipment details.
        </Warning>
      )}
    </React.Fragment>
  );
}

export default withFieldAccessors(ShippingSection);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ShippingSection/ShippingSection.jsx